export default {"src":"/_next/static/media/bug-virus.86031422.svg","height":50,"width":50,"blurWidth":0,"blurHeight":0};